
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" (click)="closeModal()"></ion-back-button>
    </ion-buttons>
    <ion-title>Neues Ticket</ion-title>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}" swipeback (swipedBack)="closeModal()">

  <section>
    <!-- <h2>Neues Ticket</h2> -->
    <div class="nt-item">
      <h3>Bezeichnung</h3>
      <input #description type="text" class="template-input" placeholder="Bezeichnung..." [value]="descriptionText" (keydown)="checkDescriptionEnter($event)" [(ngModel)]="descriptionText">
    </div>
    <div class="nt-item">
      <h3>Adresse</h3>
      <div style="display: flex; column-gap: 5px;">
        <input readonly #address type="text" class="template-input" placeholder="Adresse..." (click)="showKundePopover()" value="{{kunde?.description}}"> 
        <div class="hover-bttn" *ngIf="kunde && authSrv.includesRole('employee')" (click)="openAddressDetails(kunde)">
          <ion-icon name="fa-open-new"></ion-icon>
        </div>
      </div>
    </div>
    <div class="nt-item" *ngIf="authSrv.role == 1">
      <h3>Art</h3>
      <input readonly #art type="text" class="template-input" placeholder="Art..." (click)="showArtPopover()" [value]="selectedArt?.description">
    </div>
    <div class="nt-item" *ngIf="authSrv.role == 0">
      <h3>Beschreibung</h3>
      <textarea placeholder="Beschreibung des Problems..." [(ngModel)]="customerDescription"></textarea>
    </div>

    <div class="nt-item" *ngIf="authSrv.role == 1">
      <h3>Bearbeiter/Beobachter</h3>
      <editor-view [activeEmployeeGroupes]="workerAddingTicket?.selectedGroups" [activeEmployees]="workerAddingTicket?.selectedEmployees" [activeObserverEmployee]="workerAddingTicket?.selectedObserverEmployees" [activeObserverEmployeeGroupes]="workerAddingTicket?.selectedObserverGroups" (addEmployee)="addEmployee()"></editor-view>
    </div>

    <div class="nt-item" *ngIf="authSrv.role == 1 && generalSrv.serverVersionGreaterThan('1.7.0')">
      <h3>Priorität</h3>
      <div id="priority">
        <div class="priority-card" [class.active]="priority == 'Hoch'" (click)="priority = 'Hoch'">
          <div class="priority-icon">
            <ion-icon name="fa-arrow-up-right"></ion-icon>
          </div>
          Hoch
        </div>
        <div class="priority-card" [class.active]="priority == 'Mittel'" (click)="priority = 'Mittel'">
          <div class="priority-icon">
            <ion-icon name="fa-arrow-right"></ion-icon>
          </div>
          Mittel
        </div>
        <div class="priority-card" [class.active]="priority == 'Niedrig'" (click)="priority = 'Niedrig'">
          <div class="priority-icon">
            <ion-icon name="fa-arrow-down-right"></ion-icon>
          </div>
          Niedrig
        </div>
      </div>
    </div>

    <div class="nt-item" *ngIf="authSrv.role == 1">
      <h3>Tätigkeiten-Vorlage <span style="opacity: 0.5; font-size: 12px;">(optional)</span></h3>
      <div class="filter-bttn" (click)="addTaskTemplate()">
        <span *ngIf="!selectedTaskTemplate" class="overflow-bullets" style="opacity: 0.5; font-style: italic;">Vorlage...</span>
        <span *ngIf="selectedTaskTemplate">{{selectedTaskTemplate.description}}</span>
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" class="svg-inline--fa fa-sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
      </div>
    </div>


    <!--sonst macht es beim schließen focus in input felder-->
    <input type="text" style="display: none;">

  </section>
</ion-content>

<ion-footer [ngClass]="{'dark': isDarkmode, 'light': !isDarkmode}">
  <ion-toolbar>
    <ion-button (click)="closePopup()" mode="ios">
      Speichern & Weiter
    </ion-button>
  </ion-toolbar>
</ion-footer>
